import {orderBy} from 'lodash';

import masthead from '../assets/postcode/masthead.json';
import suburbsJson from '../assets/postcode/suburbs.json';

export function matchedMastheadPostcode(postcode, productName) {  
  const matchedLocal = masthead.reduce((acc, product) => {
        
    const isValidProduct = product.productName === productName;

    const foundLocals = isValidProduct ? product.locals.reduce((accLocals, local) => {
      const isMatched = local.suburbs.indexOf(postcode) > -1
      const matchedLocal = isMatched ? {
        displaySlug: product.displaySlug,
        productName: product.productName,
        targetDomain: product.targetDomain,
        localName: local.name,
        link: `//www.${product.targetDomain}/${local.link}`,
        categoryId: local.categoryId
      } : null;

      return matchedLocal ? [...accLocals, matchedLocal] : accLocals;
    }, []) : [];

    return [...acc, ...foundLocals];

  }, []);

  return matchedLocal;
}

export function getDistance(lat1, lon1, lat2, lon2) { // km only
  if ((lat1 == lat2) && (lon1 == lon2)) {
    return 0;
  } else {
    var radlat1 = Math.PI * lat1/180;
    var radlat2 = Math.PI * lat2/180;
    var theta = lon1-lon2;
    var radtheta = Math.PI * theta/180;
    var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
    if (dist > 1) {
      dist = 1;
    }
    dist = Math.acos(dist);
    dist = dist * 180/Math.PI;
    dist = dist * 60 * 1.1515;
    dist = dist * 1.609344; // km only
    return dist;
  }
}

/* The goal is finding the best surroundings that likely to have something */
export function getNearbySuburbs(selectedSub) {
  const lat = selectedSub.coord.lat;
  const long = selectedSub.coord.long;
  const maxNumSurroundings = 5;

  const suburbsWithDistance = suburbsJson.reduce((acc, item) => {

    const distance = getDistance(lat, long, item[3], item[4]);
    const suburbData = {
      postcode: item[0],
      name: item[1],
      state: item[2],
      lat: item[3],
      long: item[4],
      distance
    };

    const isItSelf = item[1] === selectedSub.localName && 
      item[2] === selectedSub.state &&
      item[3] === selectedSub.coord.lat &&
      item[4] === selectedSub.coord.long;

    return isItSelf ? [suburbData, ...acc] : [...acc, suburbData];
  }, []);

  const groupByName = suburbsWithDistance.reduce((acc, item) => {
    const uniqueId = `${item.name}-${item.state}`;

    if (!acc[uniqueId]) {
      acc[uniqueId] = item;
    }

    return acc;
  }, {});

  const uniqSuburbs = Object.values(groupByName);

  const orderByDistance = orderBy(uniqSuburbs, ['distance'], ['asc']);

  return orderByDistance.slice(0, maxNumSurroundings);
}

export function filterArticles(currentResults, newResults) {
  const currentTime = Math.round(new Date().getTime()/1000);
  const dayOffset = 21 * 86400; // days

  const isDuplicated = (article) => {
    const countDuplicated = currentResults.reduce((acc, item) => {
      return (item.id === article.id) ? acc + 1 : acc;
    }, 0);

    return countDuplicated > 0;
  }

  return newResults.reduce((acc, item) => {
    const liveDate = item.date.live;

    const liveDateTime = Math.round(new Date(liveDate).getTime()/1000);
    const isOldArticle = liveDateTime <= currentTime - dayOffset;
    const isValidArticle = !isOldArticle && !isDuplicated(item);

    return isValidArticle ? [...acc, item] : acc;
  }, []);
}

export function getSuburbInfoByName(suburbName, state) {
  const getSuburbInfo = suburbsJson.reduce((acc, item) => {

    const isMatched = item[2].toLowerCase() === state.toLowerCase() && 
      item[1].toLowerCase() === suburbName.toLowerCase();
    
    const uniqueId = `${state}-${item[1].toLowerCase()}`;
    const postcode = item[0];
    
    const hasValidPostcode = acc[uniqueId] && acc[uniqueId].postCode > postcode;

    if (isMatched && !hasValidPostcode) {
      const subName = item[1].toLowerCase();
      acc[subName] = {
        localName: item[1],
        postcode: item[0],
        state: item[2],
        coord: {
          lat: item[3],
          long: item[4],     
        }
      }
    }

    return acc;
  }, {});

  const matchedSuburbs = Object.values(getSuburbInfo);

  return matchedSuburbs.length > 0 ? matchedSuburbs[0] : {};
}
